import styled from 'styled-components';

export const Wrapper = styled.div`
  user-select: none;
  margin-top: 28px;
  padding-left: 16px;

  > div:last-child > div:last-child::before {
    display: none;
  }
`;

export const WrapperItem = styled.div<{
  active: boolean;
  complete: boolean;
}>`
  width: 100%;

  > div:first-child {
    > div:first-child {
      border: ${(v) =>
        v.active || v.complete ? '2px solid #5b36f2' : '2px solid #8090bb'};
      background-color: ${(v) => (v.complete ? '#5b36f2' : 'transparent')};

      > cc-icon {
        height: 16px;
        width: 16px;
        display: ${(v) => (v.complete ? 'block' : 'none')};
        color: ${(v) =>
          v.active ? '#5b36f2' : v.complete ? '#ffffff' : '#8090bb'};
      }

      > span {
        display: ${(v) => (v.complete ? 'none' : 'block')};
        color: ${(v) => (v.active ? '#5b36f2' : '#8090bb')};
      }
    }
  }
`;

export const WrapperHeader = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  background-color: transparent;
`;

export const WrapperCircle = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #8090bb;
  border-radius: 50%;
  background-color: transparent;

  > span {
    font-weight: 700;
    color: #8090bb;
  }
`;

export const WrapperMain = styled.div<{
  complete: boolean;
}>`
  position: relative;
  min-height: 32px;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 42px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: calc(30px / 2);
    transform: translateY(-50%);
    width: 2px;
    height: calc(100% - 16px);
    background-color: ${(v) => (v.complete ? '#5b36f2' : '#8090bb')};
  }
`;
